<template>
    <div>
        <template>

            <div class="row p-0 m-0">
                <div class="col-md-12 bg-white p-20">
                    <b-tabs content-class="mt-3" class="bg-" justified>
                        <b-tab title="Profile" active :title-item-class="'tab-title-class'">
                            <v-card flat>
                                <div class="row justify-content-center py-lg-10 px-lg-6">
                                    <div class="col-xl-6 col-xxl-10">
                                    <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
                                        <div class="col-xl-12 col-xxl-7">
                                            <!--begin: Wizard Form-->
                                            <form class="form" id="kt_form">
                                                <!--begin: Wizard Step 1-->
                                                <div
                                                        class="pb-5"
                                                        data-wizard-type="step-content"
                                                        data-wizard-state="current"
                                                >
                                                    <h3 class="mb-10 font-weight-bold text-dark">
                                                        Customer Info
                                                    </h3>
                                                    <div class="form-group">
                                                        <label>Avatar</label>

                                                        <v-col style="padding: 0;">
                                                            <Dropzone
                                                                    ref="myVueDropzone"
                                                                    id="dropzone"
                                                                    :options="dropzoneOptions"
                                                            ></Dropzone>
                                                        </v-col>
                                                    </div>

                                                    <div class="form-group">
                                                        <label>Customer Name</label>
                                                        <input
                                                                type="text"
                                                                class="form-control form-control-solid form-control-lg"
                                                                name="address1"
                                                                placeholder="Address Line 1"
                                                                value="VaultTrust"
                                                        />
                                                        <span class="form-text text-muted"
                                                        >Please enter your company name.</span
                                                        >
                                                    </div>

                                                    <div class="row">
                                                        <div class="col-xl-6">
                                                            <div class="form-group">
                                                                <label>Email Address</label>
                                                                <input
                                                                        type="text"
                                                                        class="form-control form-control-solid form-control-lg"
                                                                        name="postcode"
                                                                        placeholder="Postcode"
                                                                        value="ABC@ABC.com"
                                                                />
                                                                <span class="form-text text-muted"
                                                                >Please enter your email.</span
                                                                >
                                                            </div>
                                                        </div>
                                                        <div class="col-xl-6">
                                                            <div class="form-group">
                                                                <label>City</label>
                                                                <input
                                                                        type="text"
                                                                        class="form-control form-control-solid form-control-lg"
                                                                        name="city"
                                                                        placeholder="City"
                                                                        value="Melbourne"
                                                                />
                                                                <span class="form-text text-muted"
                                                                >Please enter your City.</span
                                                                >
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>

                                                <!--begin: Wizard Actions -->
                                                <div class="d-flex justify-content-between border-top pt-10">
                                                    <div class="mr-2">
                                                    </div>
                                                    <div>
                                                        <button
                                                                v-on:click="submit"
                                                                class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                                                                data-wizard-type="action-submit"
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                                <!--end: Wizard Actions -->
                                            </form>
                                            <!--end: Wizard Form-->
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </v-card>
                        </b-tab>
                        <b-tab title="Change Password">
                            <v-card flat>
                                <div class="row justify-content-center py-lg-10 px-lg-6">
                                    <div class="col-xl-6 col-xxl-10">
                                                <div class="row justify-content-center my-10 px-8 my-lg-15 px-lg-10">
                                                    <div class="col-xl-12 col-xxl-7">
                                                        <!--begin: Wizard Form-->
                                                        <form class="form">
                                                            <!--begin: Wizard Step 1-->
                                                            <div
                                                                    class="pb-5"
                                                                    data-wizard-type="step-content"
                                                                    data-wizard-state="current"
                                                            >
                                                                <h3 class="mb-10 font-weight-bold text-dark">
                                                                    Change Password
                                                                </h3>

                                                                <div class="form-group">
                                                                    <label>Original Password</label>
                                                                    <input
                                                                            type="text"
                                                                            class="form-control form-control-solid form-control-lg"
                                                                            name="address1"
                                                                            value="VaultTrust"
                                                                    />
                                                                </div>

                                                                <div class="form-group">
                                                                    <label>New Password</label>
                                                                    <input
                                                                            type="text"
                                                                            class="form-control form-control-solid form-control-lg"
                                                                            name="address1"
                                                                            value="VaultTrust"
                                                                    />
                                                                </div>

                                                                <div class="form-group">
                                                                    <label>Check New Password</label>
                                                                    <input
                                                                            type="text"
                                                                            class="form-control form-control-solid form-control-lg"
                                                                            name="address1"
                                                                            value="VaultTrust"
                                                                    />
                                                                </div>

                                                            </div>

                                                            <!--begin: Wizard Actions -->
                                                            <div class="d-flex justify-content-between border-top pt-10">
                                                                <div class="mr-2">
                                                                </div>
                                                                <div>
                                                                    <button
                                                                            v-on:click="submit"
                                                                            class="btn btn-light-primary font-weight-bold text-uppercase px-9 py-4"
                                                                            data-wizard-type="action-submit"
                                                                    >
                                                                        Submit
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <!--end: Wizard Actions -->
                                                        </form>
                                                        <!--end: Wizard Form-->
                                                    </div>
                                                </div>
                                    </div>
                                </div>
                            </v-card>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>


        </template>

        <!--begin::Card-->

        <!--end::Card-->
    </div>
</template>

<style scoped>
    .v-progress-circular {
        margin: 2rem;
    }

    .v-data-table__wrapper thead tr th {
        background-color: #f8f8f9;
        font-size: 12px !important;
    }

    .v-data-table__wrapper tbody tr td {
        font-size: 12px !important;
    }

    .zk-table__header-cell {
        color: rgba(0, 0, 0, 0.6) !important;
        padding: 6px 0;
    }

    .tab-title-class {
        font-size: 20px !important;
    }
</style>
<script>
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";

    //import TreeTable from 'primevue/treetable';

    export default {
        name: "EditUserProfile",
        components: {
            //      TreeTable
            Dropzone
        },
        computed: {
            ...mapGetters(["currentUserPhoto"])
        },
        data() {
            return {
                dropzoneOptions: {
                    url: "https://httpbin.org/post",
                    thumbnailWidth: 150,
                    maxFilesize: 0.5,
                    headers: { "My-Awesome-Header": "header value" }
                },
                kybInfo: {
                    status: "Approved"
                },
                //  Director KYC Data
                page: 1,
                pageCount: 0,
                itemsPerPage: 5,
                headers: [
                    { text: "update at (YYYY-MM-DD)", value: "updateAt" },
                    { text: "name", value: "name" },
                    { text: "Date of birth", value: "dateOfBirth" },
                    { text: "nationality", value: "nationality" },
                    { text: "status", value: "status" },
                    { text: "document", value: "document" }
                ],
                directorKycList: [
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Approved",
                        document: "ID Card"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "Hilton",
                        dateOfBirth: "1985-07-08",
                        nationality: "USA",
                        status: "Pending",
                        document: "ID Card"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Pending",
                        document: "Shareholder"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Approved",
                        document: "ID Card"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Approved",
                        document: "Shareholder"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Pending",
                        document: "ID Card"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Approved",
                        document: "Shareholder"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Pending",
                        document: "ID Card"
                    },
                    {
                        updateAt: "2020-12-05",
                        name: "hong gildong",
                        dateOfBirth: "1952-07-08",
                        nationality: "KOR",
                        status: "Pending",
                        document: "ID Card"
                    }
                ],

                // shareholder KYC data
                props: {
                    stripe: false,
                    border: false,
                    showHeader: true,
                    showSummary: false,
                    showRowHover: true,
                    showIndex: false,
                    treeType: true,
                    isFold: false, //default가 전부 열려있게 할 지 여부
                    expandType: false,
                    selectionType: false
                },
                shareholderKybList: [
                    {
                        type: "Corporate",
                        ownerName: "Steve",
                        rate: 30,
                        dateOfBirth: "1972-11-22",
                        nationality: "JPN",
                        status: "approved",
                        document: "ID Card",
                        updateAt: "2020-11-08",
                        children: [
                            {
                                type: "Corporate",
                                ownerName: "Apple",
                                rate: 20,
                                dateOfBirth: "1972-11-22",
                                nationality: "JPN",
                                status: "Pending",
                                document: "ID Card",
                                updateAt: "2020-11-08",
                                children: [
                                    {
                                        type: "Corporate",
                                        ownerName: "Hilton",
                                        rate: 70,
                                        dateOfBirth: "1972-11-22",
                                        nationality: "JPN",
                                        status: "Pending",
                                        document: "ID Card",
                                        updateAt: "2020-11-08"
                                    },
                                    {
                                        type: "Corporate",
                                        ownerName: "Jack",
                                        rate: 90,
                                        dateOfBirth: "1972-11-22",
                                        nationality: "JPN",
                                        status: "Approved",
                                        document: "ID Card",
                                        updateAt: "2020-11-08",
                                        children: [
                                            {
                                                type: "Individual",
                                                ownerName: "Lowell",
                                                rate: 80,
                                                dateOfBirth: "1972-11-22",
                                                nationality: "JPN",
                                                status: "Pending",
                                                document: "ID Card",
                                                updateAt: "2020-11-08"
                                            },
                                            {
                                                type: "Corporate",
                                                ownerName: "Wendy",
                                                rate: 30,
                                                dateOfBirth: "1972-11-22",
                                                nationality: "JPN",
                                                status: "Approved",
                                                document: "ID Card",
                                                updateAt: "2020-11-08",
                                                children: [
                                                    {
                                                        type: "Individual",
                                                        ownerName: "Jack",
                                                        rate: 50,
                                                        dateOfBirth: "1972-11-22",
                                                        nationality: "JPN",
                                                        status: "Pending",
                                                        document: "ID Card",
                                                        updateAt: "2020-11-08"
                                                    },
                                                    {
                                                        type: "Individual",
                                                        ownerName: "Freddie Mercury (프레디머큐리) ",
                                                        rate: 25,
                                                        dateOfBirth: "1972-11-22",
                                                        nationality: "JPN",
                                                        status: "Approved",
                                                        document: "ID Card",
                                                        updateAt: "2020-11-08"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                type: "Individual",
                                ownerName: "Nammy",
                                rate: 60,
                                dateOfBirth: "1972-11-22",
                                nationality: "JPN",
                                status: "Pending",
                                document: "ID Card",
                                updateAt: "2020-11-08"
                            }
                        ]
                    },
                    {
                        type: "Individual",
                        ownerName: "Kyle",
                        rate: 50,
                        dateOfBirth: "1972-11-22",
                        nationality: "JPN",
                        status: "Pending",
                        document: "ID Card",
                        updateAt: "2020-11-08"
                    }
                ],
                shareholderKycColumns: [
                    {
                        label: "ownerName",
                        prop: "ownerName",
                        minWidth: "280px"
                    },
                    {
                        label: "updateAt",
                        prop: "updateAt",
                        width: "100px"
                    },
                    {
                        label: "type",
                        prop: "type",
                        width: "100px"
                    },
                    {
                        label: "rate",
                        prop: "rate",
                        width: "60px"
                    },
                    {
                        label: "dateOfBirth",
                        prop: "dateOfBirth",
                        minWidth: "100px"
                    },
                    {
                        label: "nationality",
                        prop: "nationality",
                        minWidth: "100px"
                    },
                    {
                        label: "status",
                        prop: "status",
                        minWidth: "100px",
                        type: "template",
                        template: "status"
                    },
                    {
                        label: "document",
                        prop: "document",
                        minWidth: "100px",
                        type: "template",
                        template: "document"
                    }
                ],
                tab: null
            };
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Edit User Profile" }
            ]);
        },

        methods: {
            submit() {

                // 프로필 수정로직
            },
            getColor(status) {
                console.log(status);
                if ("Approved" == status) return "green";
                else return "orange";
            }
        }
    };
</script>
